<template>
  <AnalyzerForm
    :analyzer="$store.state.analyzers.analyzer"
    :onSubmit="submit"
  ></AnalyzerForm>
</template>

<script>
import AnalyzerForm from './AnalyzerForm.vue';
import { busEvent } from '../../main';
import { mapActions } from 'vuex';

export default {
  name: 'CreateAnalyzer',
  components: {
    AnalyzerForm,
  },
  methods: {
    ...mapActions('analyzers', ['create']),
    async submit() {
      await this.create();
      busEvent.$emit('succesPopupCreated', 'Analizorul a fost creat');
      this.$router.push({ path: '/analyzers' });
    },
  },
};
</script>
